module.exports = __webpack_public_path__ + "img/puff.27e2ef14.svg";